import { put, select } from 'redux-saga/effects';

/**
 * Generator/Saga to set requestedExcess to the quote based on selected state from overnight parking address
 * The action happens on the page where we type into an overnight address
 * @param {Object} action - 'SET_EXCESS_BY_STATE' action
 */
const setExcessByState = function* (action) {
    if (action.stateKey && action.identifier) {
        const requestedExcessValue = yield select(requestedExcessByStateCode);
        yield put({
            type: 'SET_VALUE',
            identifier: action.identifier,
            value: requestedExcessValue,
            stateKey: action.stateKey
        });
    }
};

export const requestedExcessByStateCode = (state) => {
    const coverDeail = getCoverDetail(state);
    const stateCode = coverDeail.getIn(['overnightParking', 'address', 'state']);
    const requestedExcessCurrent = coverDeail.getIn(['requestedExcess']);
    const coverType = coverDeail.getIn(['coverType']);
    // We only change requestedExcess for COMPREHENSIVE cover type
    if (coverType !== 'COMPREHENSIVE') return requestedExcessCurrent;
    return getExcess(stateCode);
};

export const getExcess = (stateCode) => ({
    NSW: 1000,
    QLD: 1000,
    VIC: 1000,
    ACT: 1000,
    WA: 900,
    NT: 900,
    SA: 900,
    TAS: 800,
})[stateCode] || 800;

export const getCoverDetail = (state) => {
    return state.getIn(['vertical', 'quote', 'form', 'coverDetail']);
};

export default ['SET_EXCESS_BY_STATE', setExcessByState];
